import * as React from 'react';
export var TextMatchHighlight = function TextMatchHighlight(props) {
  var parts = [];
  var re = RegExp(props.highlightText, 'i');
  var hand = props.text;
  var matches = re.exec(hand);
  var i = 0;
  while (matches != null) {
    i++;
    var left = hand.substr(0, matches.index);
    var slice = hand.substr(matches.index, props.highlightText.length);
    hand = hand.substr(matches.index + props.highlightText.length);
    matches = re.exec(hand);
    parts.push({
      highlight: false,
      text: left
    }, {
      highlight: true,
      text: slice
    });

    // Too many results. Break
    if (i > 5) {
      break;
    }
  }
  if (hand) {
    parts.push({
      highlight: false,
      text: hand
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, parts.map(function (p, idx) {
    return /*#__PURE__*/React.createElement("span", {
      key: idx,
      style: {
        fontWeight: p.highlight ? 'bold' : 'normal'
      }
    }, p.text);
  }));
};